import { CompanyFilterBaseDataProvider } from './CompanyFilterBaseDataProvider';
import { GetTargetsRequest, GetTargetsResponse } from '@nirvana/shared/dtos/types/alerts/gz-console';
import { GetCompaniesRequest, GetCompaniesResponse } from '@nirvana/shared/dtos/types/protected-entities/gz-console';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { CompanyEndpointMethod } from '../../../quarantine/exchangeProtection/types';

export class CompanyFilterGzTagsDataProvider extends CompanyFilterBaseDataProvider {
  async getInitialTargets(request: GetTargetsRequest): Promise<GetTargetsResponse | undefined> {
    try {
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          limit: 10,
          options: {
            source: 'fromTagsManagement',
          },
        },
      });

      return {
        defaultTarget: [],
        targets: response.data.map(({ _id, name }) => ({ companyId: _id, companyName: name })),
        totalCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }

  async getCompanies({ companyName, page, limit, params }: GetCompaniesRequest): Promise<GetCompaniesResponse | undefined> {
    try {
      const options = {
        ...params,
        source: 'fromTagsManagement',
      };
      const response = await ConsoleRequest.createRequest<any>({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'Company',
        method: CompanyEndpointMethod.GET_AVAILABLE_COMPANIES,
        payload: {
          options,
          companyName,
          limit: limit ?? 10,
          page
        },
      });

      return {
        targets: response.data.map(({ _id, name }) => ({ companyId: _id, companyName: name })),
        totalCount: response.count,
      };
    } catch (e) {
      throw new Error(e);
    }
  }
}
